import * as React from "react";
import SvgContainer from "./SvgContainer";

export default function SvgExhibitsZoomIn(props) {
  return (
    <SvgContainer title="Pencil Icon" {...props}><path fill="#fff" d="M45 53H20a8 8 0 0 1-8-8V20a8 8 0 0 1 8-8h25a8 8 0 0 1 8 8v25a8 8 0 0 1-8 8ZM20 15a5 5 0 0 0-5 5v25a5 5 0 0 0 5 5h25a5 5 0 0 0 5-5V20a5 5 0 0 0-5-5Z" /><path fill="#fff" d="M31 20h3v24h-3z" /><path fill="#fff" d="M20 31h24v3H20z" />
    </SvgContainer>
  );
}
